import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Link, Text } from '@beef/ui-kit';
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var Links = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    data = _ref.data;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('links-wrapper')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-m",
    tagType: "h3"
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: cn('links')
  }, data.map(function (link) {
    return /*#__PURE__*/React.createElement("li", {
      className: cn('links__link'),
      key: link.name
    }, /*#__PURE__*/React.createElement(Link, {
      href: link.value,
      isNoUnderline: true,
      key: link.name,
      size: "size5-r-s",
      variant: "light"
    }, link.name));
  })));
});